"use client";

import { useLocale } from "next-intl";
import { Sidebar } from "@/components/layout/sidebar";
import { WorkspaceSelector } from "@/components/workspaces/workspace-selector";
import { Navbar } from "@/components/layout/navbar";
import { useSidebar } from "@/contexts/sidebar-context";
import { cn } from "@/lib/utils";

export function DashboardLayout({ children, workspaceSelection = true }: { children: React.ReactNode; workspaceSelection?: boolean }) {
  const locale = useLocale();
  const { isCollapsed } = useSidebar();
  const isRTL = locale === "ar";

  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <div
        className={cn(
          "transition-all duration-300",
          isRTL
            ? isCollapsed
              ? "lg:mr-16"
              : "lg:mr-64"
            : isCollapsed
            ? "lg:ml-16"
            : "lg:ml-64"
        )}
      >
        <Navbar />
        {workspaceSelection && <WorkspaceSelector />}
        <main className="p-4 md:p-6">
          <div className="animate-in fade-in slide-in-from-bottom-3 duration-300 fill-mode-both">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
